import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "../ui/dialog";
import { useLang } from "../../context/LangContext";

export const SizeChart = ({ rows = [] }) => {
  const { t, lang } = useLang();
  if (!rows.length) return null;
  return (
    <Dialog>
      <DialogTrigger data-testid="size-chart-button" className="link-u text-xs tracking-[0.1em] text-gold-deep">{t("size_chart")}</DialogTrigger>
      <DialogContent className="max-w-lg rounded-none border-sand bg-ivory">
        <DialogTitle className="font-display text-2xl font-normal">{t("size_chart")}</DialogTitle>
        <table data-testid="size-chart-table" className="mt-4 w-full text-center text-sm">
          <thead>
            <tr className="border-b border-sand text-xs text-sand-dark">
              <th className="py-3">{t("size")}</th>
              <th>{lang === "ar" ? "الطول (سم)" : "Length (cm)"}</th>
              <th>{lang === "ar" ? "الصدر (سم)" : "Bust (cm)"}</th>
              <th>{lang === "ar" ? "الطول المناسب" : "Your height"}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.size} className="border-b border-sand/50">
                <td className="py-3 font-medium">{r.size}</td><td>{r.length}</td><td>{r.bust}</td>
                <td>{lang === "ar" ? r.height_ar : r.height_en}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </DialogContent>
    </Dialog>
  );
};
